import React from 'react';

export default function AiDisclaimer({ className = 'px-5 pb-4' }) {
  return (
    <div className={className}>
      <p className="text-xs text-gray-400">
        AI-generated content — may contain inaccuracies. Review before use.
      </p>
    </div>
  );
}
